import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'convertsymbol',
    standalone: false
})
export class ConvertsymbolPipe implements PipeTransform {

  transform (value: string): string {
    if (value.indexOf('&lt;') >= 0) {
      return value.replace(/&lt;/g, '<');
    } else if (value.indexOf('&gt;') >= 0) {
      return value.replace(/&gt;/g, '>');
    } else if (value.indexOf('&amp;') >= 0) {
      return value.replace(/&amp;/g, '&');
    } else if (value.indexOf('or_operator') >= 0) {
      return value.replace(/or_operator/g, 'OR');
    } else if (value.indexOf('and_operator') >= 0) {
      return value.replace(/and_operator/g, 'AND');
    }
    return value;
  }

}
